import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import Box from '@mui/material/Box';

import BackButton from '@ts-core/components/BackButton';
import PageContentLayout from '@ts-core/core/components/PageContentLayout';

import CourseForm from '../../components/CourseForm';
import { useCourseActions } from '../../hooks';
import { CourseFormInput } from '../../types/form';

const NewCoursePage = () => {
  const history = useHistory();

  const { onCreateCourse, creatingCourse } = useCourseActions();

  const handleCreateCourse = useCallback(
    (input: CourseFormInput) => {
      onCreateCourse(input, () => {
        history.push('/courses');
      });
    },
    [onCreateCourse, history]
  );

  return (
    <Box>
      <Box mb={2}>
        <BackButton title={'Agregar Curso'} subtitle="Courses" href="/courses" />
      </Box>
      <PageContentLayout>
        <CourseForm onSubmit={handleCreateCourse} isSubmitting={creatingCourse} />
      </PageContentLayout>
    </Box>
  );
};

export default NewCoursePage;
